import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { FormDirectivesAngularModule } from 'rev-shared/util/directives/form/FormDirectivesAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { SecurityAngularModule } from 'rev-shared/security/SecurityAngular.Module';
import { SelectAngularModule } from 'rev-shared/ui/select/SelectAngular.Module';
import { TemplatesMenuAngularModule } from 'rev-shared/ui/templates/TemplatesMenuAngular.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { VbBtnPrimaryDirective } from 'rev-shared/ui/buttons/VbBtnPrimary.Directive';
import { VbBtnSecondaryDirective } from 'rev-shared/ui/buttons/VbBtnSecondary.Directive';
import { VbDropdownMenuModule } from 'rev-shared/ui/dropdown-menu/VbDropdownMenu.Module';
import { VbUiTextInputDirective } from 'rev-shared/ui/textInput/VbUiTextInput.Directive';

import { GoLiveComponent } from './GoLive.Component';
import { GoLiveFormComponent } from './GoLiveForm.Component';

const declarations = [
	GoLiveComponent,
	GoLiveFormComponent
];

@NgModule({
	declarations,
	exports: declarations,
	imports: [
		BsDropdownModule,
		CommonModule,
		FormDirectivesAngularModule,
		FormGroupAngularModule,
		FormsModule,
		SecurityAngularModule,
		SelectAngularModule,
		TemplatesMenuAngularModule,
		TranslateModule,
		ValidationAngularModule,
		VbBtnPrimaryDirective,
		VbBtnSecondaryDirective,
		VbDropdownMenuModule,
		VbUiTextInputDirective
	]
})

export class GoLiveModule {}
